import classNames from "classnames"
import { Text } from "../text/text";

import styles from "./button.module.css"

export const Button = ({ className, text, before, icon: after, fixed, error, view = "normal", type = "primary", noActiveAnimation = false, buttonType = "button", ...params }) => {
    return (
        <>
            <button
                {...params}
                type={buttonType}
                className={
                    classNames(
                        styles.custom_button,
                        className,
                        styles[view],
                        styles[type],
                        {
                            [styles.with_icon]: !!after || !!before,
                            [styles.no_active_animation]: noActiveAnimation,
                            [styles.fixed]: fixed,
                            [styles.only_icon]: !text && (!!after || !!before),
                            [styles.error]: error,
                        }
                    )
                }
            >
                {
                    !!before &&
                    <div className={styles.custom_button_icon}>
                        {before}
                    </div>
                }
                {
                    !!text &&
                    <Text tag="span" view="bodyStrong" className={styles.custom_button_text} clamp={2}>{text}</Text>
                }
                {
                    !!after &&
                    <div className={styles.custom_button_icon}>
                        {after}
                    </div>
                }
            </button>
        </>
    )
}
